import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output, inject } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

import { CasinoCategorySliderNewComponent } from "@components/casino/lobby/casino-category-slider-new/casino-category-slider-new.component";
import { IonicModule } from "@ionic/angular";
import { Category } from "@models/lobby/casinoDataModels";
import { CasinoService } from "@services/casino/casino.service";
import { DeviceService } from "@services/device.service";

@Component({
  selector: "empty-search",
  imports: [CommonModule, IonicModule, TranslateModule, CasinoCategorySliderNewComponent],
  standalone: true,
  templateUrl: "./empty-search.component.html",
  styleUrls: ["./empty-search.component.scss"],
})
export class EmptySearchComponent implements OnInit {
  @Output() turnPlay: EventEmitter<number> = new EventEmitter();
  casinoService = inject(CasinoService);
  public emptyCategory: Category;
  isDesktop: boolean = false;
  device = inject(DeviceService);

  constructor() {
    this.isDesktop = this.device.isDesktop();
  }

  ngOnInit(): void {
    this.emptyCategory = this.casinoService.getEmptySearchCategory();
  }

  public playGame(event): void {
    this.turnPlay.emit(event);
  }
}
